import { useApi } from './use-api-call';
import { AccessRoleDTO } from './access-role-api';
import { AccessTeamDTO } from './access-team-api';


export const useSearchAccessTeamRoleApi = () => useApi<{ 
accessTeamRoles: AccessTeamRoleDTO[];
        accessRoles: AccessRoleDTO[];
        accessTeams: AccessTeamDTO[];
        allowEdit: boolean; 
    }>('/access-team-role/search-access-team-role');

export const useGetAccessTeamRoleApi = () => useApi<{ accessTeamRole: AccessTeamRoleDTO; allowEdit: boolean; }>('/access-team-role/get-access-team-role/{roleId}/{accessTeamSerial}');

export const useSaveAccessTeamRoleApi = () => useApi<{ accessTeamRole: AccessTeamRoleDTO}>('/access-team-role/save-access-team-role');

export const useDeleteAccessTeamRoleApi = () => useApi('/access-team-role/delete-access-team-role/{roleId}/{accessTeamSerial}');

export interface AccessTeamRoleDTO { 
roleId:string;
accessTeamSerial:number;
permissionLevel:string;
}
